import react, {useEffect, useState} from 'react';
import Loader from "../../../../Loader/Loader";
import React from "react";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import NotFoundData from "../../../../Images/no-data-found.webp";
import './review.css'
import Moment from "moment/moment";
import BottomMenu from "../../../layout/bottomMenu";
import {getAM} from "../../../../service/FasttagToll/action";

const ReviewPJP = ({
                           history,
                       pjpReview,
                       PJPReviewDetails= [],
                       getAM,
                       allAm = []
                       }) => {

    const mon =
        {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December'
        };
    const [isLoading, setIsLoading] = useState(false)
    const [showFade, setShowFade] = useState([{"pending":"show active"}])
    const [status, setStatus] = useState('pending')
    const [open, setOpen] = useState(false);
    const [filterInputList, setFilterInputList] = useState([{}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [roleId, setRoleId] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRoleId(window.localStorage.role_id);
            if(parseInt(window.localStorage.role_id) === 67){
                await getAM(2)
            } else {
                await getAM(1)
            }
            await handleToggle('pending')
            document.getElementById('pending_auto').click();
            let filter = window.localStorage.pjp_review ? JSON.parse(window.localStorage.pjp_review) : [{}];
            setFilterInputList(filter)
            await pjpReview(1, filter)
            setIsLoading(false)
        })();
    }, []);


    const handleToggle = async (status) => {
        setIsLoading(true)
        setStatus(status)
        showFade['approved'] = '';
        showFade['rejected'] = '';
        showFade['pending'] = '';
        showFade[status] = "show active";
        setShowFade(showFade)
        let filter = window.localStorage.pjp_review ? JSON.parse(window.localStorage.pjp_review) : [{}];
        await pjpReview(status === "pending" ? 1 : status === "approved" ? 2 : status === "rejected" ? 3 : 1, filter)
        setIsLoading(false)
    }


    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        window.localStorage.pjp_review = JSON.stringify(filterInputList)
        await pjpReview(status === "pending" ? 1 : status === "approved" ? 2 : status === "rejected" ? 3 : 1, filterInputList)
        setIsLoading(false)
    }

    const handleFilter = async (key, value, stringValue = '') => {
        // if(key === 'month'){
        //     value = mon[value];
        // }
        //
        // if(key === 'am' && allAm?.data){
        //     // eslint-disable-next-line no-unused-expressions,array-callback-return
        //     allAm?.data.map(val => {
        //         if(parseInt(val.id) === parseInt(value)){
        //             value = val?.name+"("+val?.email+")";
        //         }
        //     })
        // }
        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            if(filterInputList[0].length === 0){
                delete window.localStorage.pjp_review
            } else {
                window.localStorage.pjp_review = JSON.stringify(filterInputList)
            }
            await pjpReview(status === "pending" ? 1 : status === "approved" ? 2 : status === "rejected" ? 3 : 1, filterInputList)

            setIsLoading(false)
        }
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'PJP Review'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col-sm-12 col-md-12 col-lg-12 d-flex">
                                            <h4 className="card-title col-md-6 mt-3">PJP Status</h4>
                                            <div className="col-md-6 cs-pos mb-6">
                                                <button onClick={() => setOpen(!open)}
                                                        className="btn btn-sm btn-primary  mr-2 btn-filter"
                                                        type="button"><i
                                                    className="fa fa-filter lh-35 pd-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                        {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <div className="row pd-filter-div">
                                                    <div className="col-md-12 col-sm-12 mt-6 d-flex">
                                                        <div className="applied-filter">
                                                            {Object.keys(filterInputList[0]).map((val, i) => {
                                                                return (
                                                                    <>
                                                                        <span className="fd-1">
                                                                            <span style={{textTransform: "capitalize"}}>
                                                                                {val.replaceAll("_", " ")+" - "}
                                                                            </span>
                                                                            {
                                                                                val === "month" ? mon[filterInputList[0][val]] :
                                                                                val === "am" ?
                                                                                allAm?.data && allAm?.data.map(value => {
                                                                                    return (
                                                                                        <>
                                                                                            {parseInt(value?.id) === parseInt(filterInputList[0][val]) ?
                                                                                                value?.name+"("+value?.email+")" : ""
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                }) :
                                                                                    filterInputList[0][val]

                                                                            }
                                                                            <i className="bi bi-x-circle" onClick={(e) => {
                                                                                handleRemoveFilter(val)
                                                                            }}></i>
                                                                        </span>

                                                                    </>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="default-tab  mt-3">
                                            <ul className="nav nav-tabs mb-3" role="tablist">

                                                <li className="nav-item"><a className={`nav-link ${showFade}`} id="pending_auto" data-toggle="tab" href="#pending" onClick={() => {handleToggle("pending")}}>Pending</a></li>
                                                <li className="nav-item"><a className={`nav-link ${showFade}`} data-toggle="tab" href="#approved" onClick={() => {handleToggle("approved")}}>Approved</a></li>
                                                <li className="nav-item"><a className={`nav-link ${showFade}`} data-toggle="tab" href="#rejected" onClick={() => {handleToggle("rejected")}}>Rejected</a></li>
                                            </ul>
                                            <div className="tab-content">
                                                <div className={`tab-pane fade ${showFade}`} id={status} role="tabpanel">
                                                    <div className="p-t-15">
                                                        {PJPReviewDetails?.data && PJPReviewDetails?.data.length > 0 &&
                                                            PJPReviewDetails?.data.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        <div className="col-md-12 col-sm-12">
                                                                            <div className="card-padding-review">
                                                                                <a href={status === "pending" ? `pjp-pending-list/${val?.unique_id}/${val?.id}`: status === "approved" ? `pjp-approved-list/${val?.unique_id}/${val?.id}` :`pjp-rejected-list/${val?.unique_id}/${val?.id}`}>
                                                                                    <div className="card-review card-just-text-review mb-3"
                                                                                         data-color=""
                                                                                         data-radius="none">
                                                                                        <div className="content mr-3 col-md-12">
                                                                                            <div className="float-left col-md-12">
                                                                                                {val.name+" ("+val?.email+") | Submitted on : "+ (status === 'pending' ? Moment(val?.created_at).format('DD-MM-YYYY') : Moment(val?.action_date).format('DD-MM-YYYY'))}
                                                                                            </div>
                                                                                            <div className="float-right col-md-12 mt-2">
                                                                                                Total Toll: {val.total_toll}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                        {PJPReviewDetails?.data && PJPReviewDetails?.data.length === 0 &&
                                                            <div className="text-center">
                                                                <img src={NotFoundData} className="not-found-data" alt={"not found"} />
                                                                <br/>
                                                                <div style={{fontSize:"large", fontWeight:"400"}}>
                                                                    No {status} request found
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={{data:[
                            {'field' : 'dropdown', 'place_holder' : 'Month', 'values' : [
                                    {'id' : 1, 'name' : 'Jan'},
                                    {'id' : 2, 'name' : 'Feb'},
                                    {'id' : 3, 'name' : 'March'},
                                    {'id' : 4, 'name' : 'April'},
                                    {'id' : 5, 'name' : 'May'},
                                    {'id' : 6, 'name' : 'June'},
                                    {'id' : 7, 'name' : 'July'},
                                    {'id' : 8, 'name' : 'Aug'},
                                    {'id' : 9, 'name' : 'Sept'},
                                    {'id' : 10, 'name' : 'Oct'},
                                    {'id' : 11, 'name' : 'Nov'},
                                    {'id' : 12, 'name' : 'Dec'},
                                ]},
                            {'field' :'dropdown', 'place_holder' : 'Year', 'values' : [
                                    {'id' : 2024, 'name' : 2024},
                                    {'id' : 2025, 'name' : 2025},
                                    {'id' : 2026, 'name' : 2026},
                                    {'id' : 2027, 'name' : 2027},
                                    {'id' : 2028, 'name' : 2028},
                                    {'id' : 2029, 'name' : 2029},
                                    {'id' : 2030, 'name' : 2030},
                                    {'id' : 2031, 'name' : 2031},
                                    {'id' : 2032, 'name' : 2032},
                                    {'id' : 2033, 'name' : 2033},
                                    {'id' : 2034, 'name' : 2034},
                                    {'id' : 2035, 'name' : 2035},
                                ]},
                            {'field' : 'dropdown', 'place_holder' : 'AM', 'values' :allAm?.data ?? []}
                            ]
                    }
                }
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
        </>
    )
}

export default ReviewPJP